import styled from "styled-components";

export const Header = styled.div`
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 10px;
`;

export const CreditFinishedView = styled.div`
  padding: 10px 30px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  h1 {
    font-weight: 400;
    font-size: 18px;
    margin-bottom: 10px;
    text-wrap: balance;
    text-align: center;

    a {
      color: rgb(122, 137, 244);
      transition: color 0.3s;
      &:hover {
        color: rgb(30, 34, 255);
      }
    }
  }
`;

export const ModalContentWrapper = styled.div`
  padding: 30px 30px 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  position: relative;
`;

export const ButtonSection = styled.div`
  position: absolute;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 20px;
  right: 26px;
  bottom: 0px;
`;

export const PackagesSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 20px 0px;
  margin-bottom: 10px;
`;

export const InvoiceSelectorSection = styled.div`
  margin: 35px 0px 20px 0px;
`;

export const PackageHint = styled.div`
  margin-top: 14px;
  color: rgba(104, 104, 104, 0.79);
`;

export const SinglePackageCard = styled.div`
  display: flex;
  align-items: space-between;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
  margin: 10px 20px;
  ${(props) => (props.selected ? "border: 1px solid blue;" : "border: 1px solid #d7d7d7;")}
  width: 100%;
  box-shadow: rgb(0 0 0 / 25%) 0px 2px 6px;
  transition: all 0.2s ease-out;
  margin-bottom: 5px;
  &:hover {
    ${(props) => (props.selected ? "" : "transform: translateY(-2px);")}
  }
`;

export const SinglePackageCardDetailSeciton = styled.div`
  flex-basis: 80%;
  display: flex;
  justify-content: space-between;
  padding: 10px 10px;
  border-right: 0.8px solid #d7d7d7;
`;

export const SinglePackageCardTotalSeciton = styled.div`
  flex-basis: 20%;
  display: flex;
  flex-direction: column;
  padding: 20px 10px;
  align-items: center;
  text-align: right;
`;

export const SinglePackageCardDetailLeftSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SinglePackageCardDetailLeftNameSection = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const SinglePackageCardDetailSavingsSection = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  color: rgb(104 104 104 / 59%);
`;

export const SinglePackageCardTitle = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #1563ff;
  margin-bottom: 5px;
`;

export const SinglePackageCardSubtitle = styled.span`
  color: rgb(104 104 104 / 79%);
  margin-bottom: 5px;
`;

export const SinglePackageCardAmount = styled.span`
  padding-top: 5px;
`;

export const SinglePackageCardSavingsPercent = styled.span`
  padding: 5px;
  background: #e3fff2;
  border-radius: 5px;
  color: #10be6a;
  width: fit-content;
  font-size: 13px;
`;

export const SinglePackageCardRadio = styled.input`
  margin-right: 10px;
`;

export const PriceBreakdownSection = styled.div`
  margin: 50px 0px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const PriceBreakdownSingleItem = styled.div`
  min-height: 33px;
  font-size: 15px;
  min-height: 33px;
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  width: 300px;
  strong {
    width: 200px;
    text-align: right;
  }
`;

export const SingleFieldWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

export const LabelSection = styled.div`
  width: 100px;
`;

export const Input = styled.input`
  border: 1px solid hsl(0, 0%, 70%);
  padding: 0 6px;
  border-radius: 4px;
  width: 160px;
  line-height: 28px;
  transition: all 0.2s;
  &:focus,
  &:active {
    border: 1px solid #2684ff;
  }
`;
